import * as types from "./types";

export const fetchingMemberRequests = () => ({
  type: types.FETCHING_MEMBER_REQUESTS,
  loading: true
});

export const joinRequest = () => ({
  type: types.SENDING_MEMBER_REQUEST,
  loading: true
});

export const errorJoinRequest = (error) => ({
  type: types.ERROR_JOIN_REQUEST,
  error: error,
  loading: false
});


export const sendMemberRequest = (request, circleId) => ({
  type: types.SEND_MEMBER_REQUEST,
  request: request,
  circleId: circleId,
  loading: false
});


export const fetchedMemberRequests=(requests, circleId)=>({
  type: types.FETCHED_MEMBER_REQUESTS,
  requests: requests,
  circleId: circleId,
  loading: false
}); 

export const errorFetchingMemberRequests = (error) => ({
  type: types.ERROR_FETCHING_MEMBER_REQUESTS,
  error: error,
  loading: false
});

export const errorUpdatingMemberRequests = (error, requestId) => ({
  type: types.ERROR_UPDATING_MEMBER_REQUEST,
  error: error,
  requestId: requestId,
  loading: false
});

export const updatingRequestStatus=(requestId)=>({
  type: types.UPDATING_MEMBER_REQUESTS_STATUS,
  requestId: requestId
})
 
export const removeRequest=(circleId, requestId)=>({
  type: types.REMOVE_MEMBER_REQUEST,
  circleId: circleId,
  requestId: requestId
})
 
 